import { EOfferPessimizationType, IOffer, IOfferPessimization } from '../../../types';

export function prepareOfferPessimization(offer: IOffer): IOfferPessimization | null {
  const { pessimization } = offer;

  if (!pessimization) {
    return null;
  }

  return {
    text: pessimization.text as string,
    type: pessimization.type as unknown as EOfferPessimizationType,
  };
}
